import { onSessionEnd } from 'pkg/auth/session_end';

// Added by the backoffice's "Preview in app" link.
const Key = 'announcement-preview';

let kept: string | null = null;

/**
 *	Keeps a writer's preview id for this tab until it is closed, so each
 *	reload shows the latest saved version: edit, save, reload. Runs at app
 *	start, before the first redirect drops the query string, and survives the
 *	reload that signing in makes. The link opens its tab with noopener, which
 *	starts with empty session storage, so no other tab sees it.
 */
export function keepPreviewId(): void {
	kept = new URLSearchParams(window.location.search).get(Key);

	try {
		if (kept) {
			sessionStorage.setItem(Key, kept);
		} else {
			kept = sessionStorage.getItem(Key);
		}
	} catch {
		// Blocked storage: the preview lasts until the next reload.
	}
}

export function previewId(): number | null {
	return Number(kept) || null;
}

// Whoever signs in next on this tab gets the normal list.
onSessionEnd(() => {
	kept = null;

	try {
		sessionStorage.removeItem(Key);
	} catch {
		// Nothing was kept there.
	}
});
